import { ApiProperty } from '@nestjs/swagger';
import { Transform } from 'class-transformer';
import { IsInt, IsNotEmpty, IsString, Max, MaxLength, Min } from 'class-validator';

export const CLIENT_NPS_COMMENT_MAX_LENGTH = 300;

export class ClientNpsSubmitRequest {
  @ApiProperty({ minimum: 1, maximum: 10 })
  @IsInt({ message: 'Оценка должна быть целым числом' })
  @Min(1, { message: 'Оценка должна быть не меньше 1' })
  @Max(10, { message: 'Оценка должна быть не больше 10' })
  rating: number;

  @ApiProperty({ maxLength: CLIENT_NPS_COMMENT_MAX_LENGTH })
  @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
  @IsString({ message: 'Комментарий должен быть строкой' })
  @IsNotEmpty({ message: 'Комментарий обязателен' })
  @MaxLength(CLIENT_NPS_COMMENT_MAX_LENGTH, { message: `Не более ${CLIENT_NPS_COMMENT_MAX_LENGTH} символов` })
  comment: string;
}
